import React from "react"
import PropTypes from "prop-types"
import InfiniteCalendar, { Calendar, withRange } from "react-infinite-calendar"
import "react-infinite-calendar/styles.css"
import { Dropdown, Menu, Button } from "semantic-ui-react"
import { formatDistance, endOfDay, format, startOfDay, subDays } from "date-fns"
import ruLocale from "date-fns/locale/ru"
import bind from "bind-decorator"
import { withTranslation } from "react-i18next"

const dayMilliseconds = 60 * 60 * 24 * 1000

const thisYear = new Date().getFullYear()
const vis = thisYear % 4 === 0

const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
]

const yearsRange = 10
const years = []

for (let i = 0; i < yearsRange; i++) {
  const year = {}
  year["key"] = thisYear - i
  year["value"] = thisYear - i
  year["text"] = thisYear - i
  years.push(year)
}

const months = [
  { key: 0, value: 0, text: "January" },
  { key: 1, value: 1, text: "February" },
  { key: 2, value: 2, text: "March" },
  { key: 3, value: 3, text: "April" },
  { key: 4, value: 4, text: "May" },
  { key: 5, value: 5, text: "June" },
  { key: 6, value: 6, text: "July" },
  { key: 7, value: 7, text: "August" },
  { key: 8, value: 8, text: "September" },
  { key: 9, value: 9, text: "October" },
  { key: 10, value: 10, text: "November" },
  { key: 11, value: 11, text: "December" },
]

@withTranslation()
class SharderLineGraphicDatePicker extends React.Component {
  constructor(props) {
    super(props) // props(type:{years,months,weeks},lineId)
    this.state = {
      opened: false,
      startDate: null,
      endDate: null,
      year: new Date().getFullYear(),
      month: 0,
      weeks: [],
    }
  }

  componentDidMount() {
    console.log(this.props)
  }

  getMonths = () => {
    const { t } = this.props
    return (
      <Dropdown
        placeholder={t("select") + " " + t("month")}
        selection
        options={months.map((q) => {
          const v = {}
          v.key = q.key
          v.value = q.value
          v.text = t(q.text)
          return v
        })}
        onChange={(e, value) => {
          this.setMonth(value.value)
        }}
        style={{ display: "inline-block" }}
      />
    )
  }

  setMonth = (key) => {
    if (this.props.type === "months") {
      let startDate = new Date(this.state.year, key, 1)
      let endDate = new Date(this.state.year, key + 1, 0)
      this.setState({
        month: key,
        startDate: new Date(this.state.year, key, 1),
        endDate: new Date(this.state.year, key + 1, 0),
      })
      this.props.setShardedAnalyticDateFunction(
        this.props.id,
        startDate,
        endDate,
      )
      this.props.refreshShardedAnalytic(this.props.id)
    } else if (this.props.type === "weeks") {
      this.setState({ month: key })
    }
  }

  getYears = () => {
    const { t } = this.props
    return (
      <Dropdown
        placeholder={t("select") + " " + t("year")}
        selection
        options={years}
        onChange={(e, value) => {
          this.setYear(value.value)
        }}
        style={{ display: "inline-block" }}
      />
    )
  }

  setYear = (key) => {
    if (this.props.type === "years") {
      this.setState({
        year: key,
        startDate: new Date(key, 0),
        endDate: new Date(key + 1, 0, 0),
      })
      let startDate = new Date(key, 0)
      let endDate = new Date(key + 1, 0, 0)
      this.props.setShardedAnalyticDateFunction(
        this.props.id,
        startDate,
        endDate,
      )
      this.props.refreshShardedAnalytic(this.props.id)
    } else {
      this.setState({ year: key })
    }
  }

  getWeeks = () => {
    const { t } = this.props
    const weeks = []
    const year = this.state.year
    const month = this.state.month
    const startWeekDay = new Date(year, month).getDay()
    const endweekDay = new Date(year, month + 1, 0).getDay()
    let startDay = new Date(
      year,
      month,
      1 - (startWeekDay === 0 ? 7 : startWeekDay) + 1,
    )
    let endDay = new Date(
      year,
      month + 1,
      0 + (endweekDay === 0 ? 7 : endweekDay) - 1,
    )
    let q = 0
    // eslint-disable-next-line no-unmodified-loop-condition
    while (endDay > startDay) {
      let temp = new Date(
        startDay.getFullYear(),
        startDay.getMonth(),
        startDay.getDate(),
      )
      startDay.setDate(startDay.getDate() + 6)
      let tempp = new Date(
        startDay.getFullYear(),
        startDay.getMonth(),
        startDay.getDate(),
      )
      weeks.push({
        key: q,
        value: [temp, tempp],
        text: temp.toDateString() + " " + tempp.toDateString(),
      })
      q += 1
      startDay.setDate(startDay.getDate() + 1)
    }
    // const weeks = this.state.weeks
    return (
      <Dropdown
        placeholder={t("select week")}
        selection
        options={weeks}
        onChange={(e, value) => {
          this.setWeek(value.value)
        }}
        style={{ display: "inline-block" }}
      />
    )
  }

  setWeek = (el) => {
    this.setState({ startDate: el[0], endDate: el[1] })
    let startDate = el[0]
    let endDate = el[1]
    this.props.setShardedAnalyticDateFunction(this.props.id, startDate, endDate)
    this.props.refreshShardedAnalytic(this.props.id)
  }

  getValues = () => {
    const type = this.props.type
    if (type === "weeks") {
      return (
        <>
          {this.getMonths()}
          <span></span>
          {this.getWeeks()}
        </>
      )
    } else if (type === "months") {
      return (
        <>
          {this.getYears()}
          {this.getMonths()}
        </>
      )
    } else if (type === "years") {
      return <> {this.getYears()} </>
    } else {
      return <div>No type</div>
    }
  }

  static format(date) {
    return format(date, "d MMM yyyy", { locale: ruLocale })
  }

  render() {
    return <>{this.getValues()}</>
  }
}

export default withTranslation()(SharderLineGraphicDatePicker)
